export default __webpack_public_path__ + "static/media/clinical-app-8.32068156.jpg";